import { Reveal } from "./motion";
import { IMAGES, ADVISORY } from "../../lib/siteData";

export const Advisory = () => {
  return (
    <section id="approach" data-testid="advisory-section" className="relative bg-ink py-28 md:py-40">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-1 gap-14 md:grid-cols-12 md:gap-16">
          {/* left: image + headline */}
          <div className="md:col-span-5">
            <Reveal>
              <span className="font-body text-xs font-bold uppercase tracking-[0.25em] text-brand">{ADVISORY.overline}</span>
              <h2 className="mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold uppercase leading-[0.95] tracking-tighter">
                {ADVISORY.title}
              </h2>
              <p className="mt-6 font-body text-lg font-light leading-relaxed text-neutral-400">{ADVISORY.body}</p>
            </Reveal>
            <Reveal delay={0.15} y={50}>
              <div className="group relative mt-10 aspect-[4/3] overflow-hidden rounded-2xl border border-white/10">
                <img
                  src={IMAGES.advisory}
                  alt="Experienced professionals in a working session"
                  className="h-full w-full object-cover grayscale transition-all duration-700 ease-out group-hover:grayscale-0 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent" />
              </div>
            </Reveal>
          </div>

          {/* right: numbered points */}
          <div className="md:col-span-7 md:pl-8">
            {ADVISORY.points.map((p, i) => (
              <Reveal key={p.t} delay={i * 0.06}>
                <div className="group grid grid-cols-[auto,1fr] gap-6 border-t border-white/10 py-8">
                  <span className="font-heading text-xl font-medium text-brand">0{i + 1}</span>
                  <div>
                    <h3 className="font-heading text-xl sm:text-2xl font-medium uppercase tracking-tight text-white">
                      {p.t}
                    </h3>
                    <p className="mt-2 max-w-xl font-body text-base font-light leading-relaxed text-neutral-400">
                      {p.d}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
